import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountingPaymentSchema = withDefaults({
  type: 'accounting-payment',
  objectExtensions: ['accounting-payment'],
  fields: [
    {
      kind: 'attribute',
      name: 'paymentDate',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'tag',
    },
    {
      kind: 'attribute',
      name: 'messageId',
    },
    {
      kind: 'attribute',
      name: 'paymentPath',
    },
    {
      kind: 'attribute',
      name: 'paymentType',
    },
    {
      kind: 'attribute',
      name: 'stats',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'total',
    },
    {
      kind: 'attribute',
      name: 'achAmount',
    },
    {
      kind: 'attribute',
      name: 'checkAmount',
    },
    {
      kind: 'hasMany',
      name: 'accountingTransactions',
      type: 'accounting-transaction',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'accountingInvoices',
      type: 'accounting-invoice',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'bulkAchPayments',
      type: 'bulk-ach-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AccountingPaymentSchema;
